import { createSelector } from 'reselect'
import getCheckoutTotalsView from 'checkout/selectors/payment/getCheckoutTotalsView'
import getAllItemViewsByType from './getAllItemViewsByType'
import isExperiencesPassportReady from './isExperiencesPassportReady'

/**
 * Tells us whether or not all the data has been loaded to represent the checkout
 * i.e. is it "ready" and/or "done"
 */
const isCheckoutReady = createSelector(
  (state: App.State) => getAllItemViewsByType(state),
  (state: App.State) => getCheckoutTotalsView(state),
  (state: App.State) => state.checkout.isCartRestored,
  isExperiencesPassportReady,
  (allViews, checkoutTotalsView, restored, experiencesPassportReady) => {
    return restored && experiencesPassportReady && allViews.hasRequiredData && checkoutTotalsView.hasRequiredData
  },
)

export default isCheckoutReady
